;(function(){

	var $header = {
		root: $site.header,
		nav: $site.header.find('#primary-nav'),
		overlay: $('#site-header__overlay'),
		background: $('#site-header__background')
	};

	if (!$header.nav.length) {
		return;
	}

	var header = {
		ready: false,
		timer: false,
		init: function(){

			// Clear any timers
			if( header.timer )
				clearTimeout(header.timer);

			// If we're not ready, get ready
			if( header.ready ) return false;

			// Ready now
			header.ready = true;

			// Add to the site header nav
			$header.nav = {
				root: $header.nav,
				list: $header.nav.children('ul.primary-nav__list'),
				overflow: {
					wrapper: $header.nav.find('#primary-nav__overflow-wrapper'),
					toggle: $header.nav.find('#primary-nav__overflow-toggle'),
					list: false
				},
				dropdowns: $header.nav.find('.primary-nav-dropdown'),
				dropdownActive: false
			};

			header.ready = true;

			// Apply layout
			header.layout();

			// Show the nav
			TweenLite
				.set($header.nav.root, {
					visibility: 'visible'
				});

			// Dropdown
			if( !Modernizr.touchevents )
				$header.nav.dropdowns.each(header.dropdown);

			// Toggle the overflow
			$header.nav.overflow.toggle
				.on('click', function(e){

					header.overflow.toggle();

					e.preventDefault();

				});

			$header.overlay
				.on('click', function(e){

					if( header.overflow.open )
						header.overflow.toggle(false);

				});

		},
		layout: function(){

			header.overflow.check();

		},
		overflow: {
			active: false,
			open: false,
			create: function(){

				$header.nav.overflow.list = $('<ul/>', {
					'class': 'primary-nav__overflow'
				}).appendTo($header.nav.overflow.wrapper);

			},
			toggle: function(toggle){

				header.overflow.open = typeof toggle != 'undefined' ? toggle : !header.overflow.open;

				$header.nav.overflow.toggle.toggleClass('primary-nav__overflow-toggle--active', header.overflow.open);
				$header.overlay.toggle(header.overflow.open);

			},
			enable: function(toggle){

				if( toggle && !$header.nav.overflow.list ){
					header.overflow.create();
				}else if( !toggle && $header.nav.overflow.list ){
					$header.nav.overflow.list.empty();
				}

				TweenLite
					.set($header.nav.overflow.wrapper, {
						display: toggle ? 'inline-block' : 'none'
					});

				header.overflow.active = toggle;

			},
			check: function(){

				// Reset the toggle
				header.overflow.enable(false);

				// Get the list items
				var $list = $header.nav.list.children('li.primary-nav__item');

				// Reset the nav items
				TweenLite
					.set($list, {
						clearProps: 'all'
					});

				// Get the max width (this could change on the fly)
				var listWidth = $header.nav.list.innerWidth(),
					rootWidth = $header.nav.root.width(),
					overflows = listWidth > rootWidth;

				$header.nav.root.toggleClass('primary-nav--overflows', overflows);

				if( overflows ){

					header.overflow.enable(true);

					var maxWidth = rootWidth - $header.nav.overflow.wrapper.outerWidth(true);

					$list
						.each(function(){

							var $li = $(this),
								rightEdge = $li.position().left + $li.outerWidth(true),
								overflow = rightEdge > maxWidth;

							if( overflow ){

								// Clone it into the overflow list
								$li
									.clone()
									.removeClass('primary-nav__item')
									.appendTo($header.nav.overflow.list);

								// Hide it
								$li.hide();

							}

						});

				}

			}
		},
		dropdown: function(){

			var $dd = $(this),
				$li = $dd.closest('.primary-nav__item'),
				active = false,
				timer = false;

			// Not sure why...
			$li.addClass('primary-nav__item--has-dropdown');

			var tidy = function(){

				// Hide the overlay
				$header.overlay.toggle(false);

				// Add the nav back into the list item
				$dd.off('.dropdown')
					.appendTo($li);

				// Remove the classes
				$li.off('.dropdown')
					.removeClass('primary-nav__item--dropdown-open');

				// None are active if we reach the end of a timer
				$header.nav.dropdownActive = false;

				active = false;

			};

			var hide = function(skip){

				if( typeof skip == 'boolean' && skip ){

					tidy();

				}else{

					timer = setTimeout(tidy, 300);

				}

			};

			// Custom event
			$dd.on('hide', function(){
				clearTimeout(timer);
				hide(true);
			});

			$li.on('mouseenter', function(){
				//If mobile stop the dropdown appearing
				if(site.width <= 768)
					return;


				if( active ){

					// Clear the hide timer
					clearTimeout(timer);

				}else{

					$li
						.one('mouseleave.dropdown', function(){
							clearTimeout(timer);
						});

					timer = setTimeout(function(){

						$li.off('.dropdown');

						if( $header.nav.dropdownActive )
							$header.nav.dropdownActive.trigger('hide');

						// Store the current
						$header.nav.dropdownActive = $dd;

						// Move the menu and add the classes to the nav item
						$li.addClass('primary-nav__item--dropdown-open');
						$dd.appendTo($header.root);

						// Animations
						TweenLite
							.fromTo($dd, .5, {
								scaleY: .95,
								transformOrigin: '50% 0'
							},{
								scaleY: 1,
								ease: Elastic.easeOut,
								force3D: true
							});

						TweenLite
							.fromTo($dd, .05, {
								y: '-10%'
							},{
								y: '0%',
								ease: Cubic.easeOut
							});

						// Show the overlay
						$header.overlay.toggle(true);

						// Add LI mouseleave event
						$li.on('mouseleave.dropdown', hide);

						// Add DD mouseenter event
						$dd.on('mouseenter.dropdown', function(){

							clearTimeout(timer);

							$dd.one('mouseleave.dropdown', hide);

						});

						active = true;

					}, 100);

				}

			});

		}
	};

	// Initialise the header, but delay it a little.
	// If the page load event happens in the meantime this will be cancelled
	// This ensures that the page loads as quick as possible without re-calculating a split second later
	header.timer = setTimeout(header.init, 500);

	// Add a resize event to the global listener
	site.resize.after['header'] = header.layout;

	// Fire it on load, once fonts have loaded
	$core.win.load(header.init);

	// Add the objects to the core site objects
	site['header'] = header;
	$site.header = $header;

}());
